module.exports = __webpack_public_path__ + "img/9788983945068.43ea2d61.jpg";